import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { Observable, Subscription, timer } from 'rxjs';
import { AutofocusDirective } from '../../directives/auto-focus.directive';
import { fadeIn } from 'src/assets/utility/transitions';

@Component({
  selector: 'bey-otp',
  templateUrl: './bey-otp.component.html',
  styleUrls: ['./bey-otp.component.scss'],
  standalone: true,
  animations: [fadeIn],
  imports: [NgFor, NgIf, ReactiveFormsModule, FormsModule, AsyncPipe, AutofocusDirective],
})
export class BeyOtpComponent implements OnInit, OnDestroy, AfterViewInit {
  /****
   * Number of OTP blocks
   */
  @Input()
  numberOfFields: number = 6;

  /****
   * Number of seconds before enabling the ability to resend
   */
  @Input()
  counterSeconds: number = 60;

  /****
   * Boolean value to detect the loading state
   */
  @Input()
  isLoading$: Observable<boolean>;

  /****
   * An event to be emitted once the code changes
   */
  @Output()
  onCodeChange: EventEmitter<string> = new EventEmitter();

  /****
   * An event to be emitted once the resend button gets clicked
   */
  @Output()
  onResendClick: EventEmitter<void> = new EventEmitter();

  fields: Array<number>;
  values: Array<number>;
  counter: number;
  code = '';

  subs$: Subscription = new Subscription();

  constructor() {}

  ngOnInit(): void {
    this.fields = Array.from({ length: this.numberOfFields }).map((x, i) => i);
    this.values = Array.from({ length: this.numberOfFields });
    this.counter = this.counterSeconds;

    this.subs$.add(
      timer(0, 1000).subscribe(() => {
        if (this.counter !== 0) {
          --this.counter;
        }
      })
    );
  }

  ngAfterViewInit() {
    const el = document.querySelector('#field_0') as HTMLInputElement;
    el.focus();
  }

  stepForward(to, e) {
    const { target } = e;
    target.value = target.value.slice(0, 1);

    //remove focus from last input
    if (to === this.numberOfFields - 1) {
      target.blur();
    }

    if ((document.getElementById(`field_${to}`) as HTMLInputElement).value && to !== this.numberOfFields - 1) {
      const fieldElement = document.getElementById(`field_${to + 1}`) as HTMLInputElement;

      fieldElement.focus();
      fieldElement.value = '';
    }

    this.checkPin();
  }

  stepBack(from) {
    if (from - 1 < 0) return;
    const currentField = document.getElementById(`field_${from}`) as HTMLInputElement;
    const fieldElement = document.getElementById(`field_${from - 1}`) as HTMLInputElement;

    if (fieldElement.value && from !== 0) {
      fieldElement.value = '';
      currentField.value = '';
      fieldElement.focus();
    }
  }

  resetValue(i) {
    for (let x = 0; x <= this.numberOfFields; x++) {
      if (x >= i) (document.getElementById(`field_${i}`) as HTMLInputElement).value = '';
    }
    // todo set val to null
    // this.$emit('input', null)
  }

  checkPin() {
    let code = '';
    for (let i = 0; i < this.numberOfFields; i++) {
      code = code + (document.getElementById(`field_${i}`) as HTMLInputElement).value;
    }

    this.onCodeChange.emit(code);
  }

  onChange(): void {
    this.onCodeChange.emit(this.code);
  }

  onClickResend(): void {
    this.code = '';
    this.counter = this.counterSeconds;
    this.onResendClick.emit();
  }

  ngOnDestroy(): void {
    this.subs$.unsubscribe();
  }
}
